import $ from 'jquery';

$(function () {
    /**
     * People list filter
     */
    if ($('.people-list').length) {
        var regions = $('.people-list').find('.region');
        var regionArray = [];

        var prevValue = '';
        regions.each(function(){
            var value = $(this).html();
            if (value !== prevValue) regionArray.push(value);
            prevValue = value;
        })

        var optionString = '';
        var oldRegion = [];

        regionArray.map(function(region){

            if (oldRegion.includes(region)) {
              return
            } else {
              optionString += '<option value="' + region + '">' + region + '</option>';
            }
            oldRegion.push(region);

        });

        var selectString = '<div class="filter-container">';
        selectString += '<h5>Choose a region below</h5>';
        selectString += '<select class="filter-select">';
        selectString += '<option selected disabled>Filter by regions</option><option value="All">All</option>';
        selectString += optionString;
        selectString += '</select>';
        selectString += '</div>';

        $('.filter-container').prepend(selectString);

        $('.filter-select').change( function(){
            var val = $(this).val();

            if (val == "All") {
                $('.people-list .ambassador').css('display', 'block');
            } else {
                $('.people-list .ambassador').css('display', 'none');

                $('.people-list .ambassador').each(function(){
                    var region = $(this).find('.region').html();

                    if (val == region) {
                        $(this).css('display', 'block');
                    }
                })
            }

        })
    }

    /**
     * Videos filter year
     */
    if ($('.product-container').length) {
        var years = $('.product-container').find('.year');
        var yearArray = [];

        var prevValue = '';
        years.each(function(){
            var value = $(this).html();
            if (value !== prevValue) yearArray.push(value);
            prevValue = value;
        })

        var optionString = '';

        var oldYear = [];

        yearArray.map(function(year){
          if (oldYear.includes(year)) {
            return;
          } else {
            optionString += '<option value="' + year + '">' + year + '</option>';
          }

            oldYear.push(year);
        });

        var selectString = '<div class="filter-container">';
        selectString += '<select class="filter-select-year">';
        selectString += '<option selected value="All">Year</option>';
        selectString += optionString + '</select>';
        selectString += '</div>';

        $('.filter-wrapper').prepend(selectString);

        $('.filter-select-year').change( function(){
            var val = $(this).val();
            console.log('value = ' + val);

            if (val == "All") {
                $('.product-container .product').css('display', 'block');
            } else {
                $('.product-container .product').css('display', 'none');

                $('.product-container .product').each(function(){
                    var year = $(this).find('.year').html();
                    if (val == year) {
                        $(this).css('display', 'block');
                        console.log('year = ' + year);
                    }
                })
            }

        })
    }

    /**
     * Videos filter Sector
     */
    if ($('.product-container').length) {
        var sectors = $('.product-container').find('.sector');
        var sectorArray = [];

        var prevValue = '';
        sectors.each(function(){
            var value = $(this).html();
            if (value !== prevValue) sectorArray.push(value);
            prevValue = value;
        })

        var optionString = '';

        var oldSector= [];

        sectorArray.map(function(sector){
            if (oldSector.includes(sector)) {
              return;
            } else {
                optionString += '<option value="' + sector + '">' + sector + '</option>'
            }
            oldSector.push(sector);
        });

        var selectString = '<div class="filter-container">';
        selectString += '<select class="filter-select-sector">';
        selectString += '<option value="All" selected>Sector</option>';
        selectString += optionString + '</select>';
        selectString += '</div>';

        $('.filter-wrapper').prepend(selectString);

        $('.filter-select-sector').change( function(){
            var val = $(this).val();

            if (val == "All") {
                $('.product-container .product').css('display', 'block');
            } else {
                $('.product-container .product').css('display', 'none');

                $('.product-container .product').each(function(){
                    var sector = $(this).find('.sector').html();

                    if (val == sector) {
                        $(this).css('display', 'block');
                    }
                })
            }

        })
    }

});



// WEBPACK FOOTER //
// ./resources/assets/js/components/filters.js